import { fetchApi } from '@/config/axiosSetting';
import {
  WalletPeriodsQueryParamsType,
  WalletPeriodsQueryResponseType,
} from './walletPeriodsQuery.type';

export const walletPeriodsFunction = (
  params: WalletPeriodsQueryParamsType,
): Promise<WalletPeriodsQueryResponseType> => {
  return fetchApi.get('financial/periods/', { params });
};
